
import BatteryList from '../batteries/BatteryList.vue';
import Pagination from './pagination/Pagination.vue';
import ProductSummaryCard from './ProductSummaryCard.vue';
import SkeletonLoaderWrapper from './loaders/SkeletonLoaderWrapper.vue';
import TireList from '../tires/TireList.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Get, Sync } from 'vuex-pathify';
import { HawkTrackingProductClickRequest } from '../../../types/HawkSearch';
import { IBatteryProductListQueryResult, IHawkSearchWebResultJson, ITireProductListQueryResult } from '../../../types/Catalog';
import { IListableProductJson } from '../../../types/Product';

const COLUMNS = {
	mobile: 1,
	tablet: 3,
	desktop: 4,
};

@Component({
	name: 'ProductListApp',
	components: {
		BatteryList,
		ProductSummaryCard,
		Pagination,
		SkeletonLoaderWrapper,
		TireList,
	}
})
class ProductListApp extends Vue {

	/* Computed
	============================================*/
	@Sync('searchResult@products')
	products: IListableProductJson[];

	@Get('searchResult@tireQueryResult')
	tireQueryResult: ITireProductListQueryResult | null;

	@Get('searchResult@batteryQueryResult')
	batteryQueryResult: IBatteryProductListQueryResult | null;

	@Get('searchResult@totalProducts')
	totalSearchResults: number;

	@Get('isBatteryList')
	isBatteryList: boolean;

	@Get('isTireList')
	isTireList: boolean;

	@Get('showProducts')
	showProducts: boolean;

	@Sync('productListTopEl')
	productListTopEl: HTMLElement;

	@Get('isLoadingSearchResult')
	isLoading: boolean;

	/* Data
	============================================*/
	searchResult: IHawkSearchWebResultJson | null = null;

	/* Methods
	============================================*/
	initBusListeners(): void {
		window.vueEventBus.$on('catalog:update-products', (products: IListableProductJson[]) => this.updateProducts(products));
	}

	updateProducts(products: IListableProductJson[]): void {
		this.searchResult = {
			...this.searchResult,
			products
		};
	}

	initData() {
		this.searchResult = (window as any).searchResult;
	}

	isProductInLastRow(index: number): boolean {
		const productsPerRow = COLUMNS[this.$mq];

		let productsInLastRow = this.products.length % productsPerRow;
		productsInLastRow = productsInLastRow === 0 ? productsPerRow : productsInLastRow;

		return index >= this.products.length - productsInLastRow;
	}

	isProductInLastColumn(index: number): boolean {
		const numberOfColumns = COLUMNS[this.$mq];

		return (index + 1) % numberOfColumns === 0;
	}

	/* Lifecycle Hooks
	============================================*/
	created() {
		this.initBusListeners();
		this.initData();
	}

	recordProductClick(clickRequest: HawkTrackingProductClickRequest) {
		// @ts-ignore
		window.blainGtmDataLayer.push({
			'blainNumber': clickRequest.blainNumber,
			'vendorBrand': clickRequest.vendorBrand,
			'productName': clickRequest.productName,
			'currentPrice': clickRequest.mapSafePrice,
			'belowMap': clickRequest.belowMap,
			'priceMode': clickRequest.priceMode,
			'itemListID': clickRequest.itemListID,
			'itemListName': clickRequest.itemListName,
			'itemListIndex': clickRequest.index,
			'event': "product_list_click"
		});

		// @ts-ignore
		return HawkSearch.TrackingActions.productCatalogClick(clickRequest.event, clickRequest.index, clickRequest.blainNumber);
	}

	mounted() {
		const topEl = this.$refs?.topOfProductList as Vue;

		this.productListTopEl = topEl?.$el as HTMLElement;
	}
}

export default ProductListApp;
